import { Directive, Input } from "@angular/core";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzCellBreakWordDirective } from "ng-zorro-antd/table";

@Directive({
  selector: "th[uiBreakWord],td[uiBreakWord]",
  host: {
    "[style.word-break]": `nzBreakWord ? 'break-all' : ''`,
  },
})
export class UiCellBreakWordDirective extends NzCellBreakWordDirective {
  @Input("uiBreakWord") @InputBoolean() public nzBreakWord = true;
}
